import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useMemberCyclePayments({ cycleId, memberId }) {
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    setPayments(null);

    axios
      .get(routes.api.member_benefit_payments.list, {
        params: { cycle_id: cycleId, member_id: memberId },
      })
      .then((response) => {
        setPayments(response.data.data);
      });
  }, [cycleId, memberId]);

  return payments;
}
